
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/media/partner",
      function () {
        return require("private-next-pages/media/partner/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/media/partner"])
      });
    }
  